/* eslint-disable no-void */
import React, { PureComponent } from "react";
import "./sortingView.css";

export const sortOption = {
  ASC: 1,
  DESC: -1,
  NONE: 0,
};

export class SortingView extends PureComponent {
  sortAScOrder = () => {
    const { onToggle } = this.props;
    onToggle(sortOption.ASC);
  };

  sortDesOrder = () => {
    const { onToggle } = this.props;
    onToggle(sortOption.DESC);
  };

  render() {
    const { columnKey, sortBy } = this.props;
    let asc = void 0;
    let des = void 0;
    if (columnKey && sortBy) {
      const key = sortBy ? Object.keys(sortBy)[0] : null;
      if (key === columnKey) {
        asc = sortBy[key] === 1;
        des = sortBy[key] === -1;
      }
    }
    return (
      <span className="sort-view-wrapper">
        <span className="sort-icon-wrapper ">
          <span
            data-testid="sort-asc"
            className={asc ? "sort-icon sort-arrow-up" : "sort-icon sort-arrow-up deactive"}
            aria-hidden="true"
            onClick={this.sortAScOrder}
          />
          <span
            className={des ? "sort-icon sort-arrow-down" : "sort-icon sort-arrow-down deactive"}
            aria-hidden="true"
            onClick={this.sortDesOrder}
          />
        </span>
      </span>
    );
  }
}
